<template>
	<div class="xs-12">
		<!-- Headline -->
		<div class="flex xs-12 xs-between">
			<div class="fs5 lh125 fw7 c1 mb2">{{ $t("info") }}</div>
		</div>

		<!-- Body -->
		<j-card class="bg4--l3">
			<j-list :list="computedInfo">
				<div class="flex xs-12 p3" slot="list" slot-scope="{ item }">
					<div class="flex xs-6 xs-left xs-middle fw7 c6">{{ item.label }}</div>
					<div v-if="item.label === $t('status')" class="flex xs-6 xs-right xs-middle">
						<j-tag
							:label="item.value"
							:variant="
								item.variant ? item.variant : decideStatusStyle(item.value)
							"
						/>
					</div>
					<div v-else class="flex xs-6 xs-right xs-middle">
						<span>{{ item.value }}</span>
					</div>
				</div>

				<!-- Empty -->
				<div class="xs-12 p4 ta2 fs3 c6" slot="empty">{{ $t("errors.no_data") }}</div>
			</j-list>
		</j-card>
	</div>
</template>

<script>
import JButton from "@/components/JButton/"
import JCard from "@/components/JCard/"
import JList from "@/components/JList/"
import JTag from "@/components/JTag/"
import dayjs from "dayjs"
import get from "lodash.get"

export default {
	components: {
		JButton,
		JCard,
		JList,
		JTag
	},

	data() {
		return {}
	},

	props: {
		// Data to display that we get from graphql
		// it should be an object containing:
		data: {
			type: Object,
			required: true,
			default: () => ({
				status: null,
				createdAt: null,
				createdBy: null,
				lastModifiedAt: null,
				lastModifiedBy: null,
				referrer: null
			})
		},

		hasStatus: {
			type: Boolean,
			default: true
		},

		hasReferral: {
			type: Boolean,
			default: true
		}
	},

	computed: {
		computedInfo() {
			let output = []

			output = [
				{
					label: this.$t("created"),
					value: this.data.createdAt
						? dayjs(this.data.createdAt).format(
								this.$store.state.settings
									.dateTimeFormat
						  )
						: null
				},
				{
					label: this.$t("created_by"),
					value: get(this, "data.createdBy.username")
				},
				{
					label: this.$t("updated"),
					value: this.data.lastModifiedAt
						? dayjs(this.data.lastModifiedAt).format(
								this.$store.state.settings
									.dateTimeFormat
						  )
						: null
				},
				{
					label: this.$t("updated_by"),
					value: get(this, "data.lastModifiedBy.username")
				}
			]

			// Status
			if (this.hasStatus)
				output.unshift({
					label: this.$t("status"),
					value: this.data?.status?.value
						? this.$t(this.data.status.value)
						: this.$t(this.data.status) || "---",
					variant: this.data.status?.variant || null
				})

			// Referral
			if (this.hasReferral)
				output.push({
					label: this.$t("referrer"),
					value: this.data.referrer
						? this.data.referrer.name
						: null
				})

			return output
		}
	},

	mounted() {
		// console.clear()
		// console.log(this.computedInfo)
	},

	methods: {
		decideStatusStyle(status) {
			const errorStatuses = ["CANCELLED", "REJECTED"]
			const successStatuses = ["ISSUED", "APPROVED"]
			const warningStatuses = ["QUOTING", "UNDEFINED", "PROCESSING"]
			if (errorStatuses.find(item => item === status.toUpperCase()))
				return "error"
			if (
				successStatuses.find(
					item => item === status.toUpperCase()
				)
			)
				return "success"
			if (
				warningStatuses.find(
					item => item === status.toUpperCase()
				)
			)
				return "warning"
		}
	}
}
</script>
